/**
 * Read Django SimpleJWT `user_id` from an access token payload (no verification).
 */
export function userIdFromAccessToken(accessToken: string | null): number | null {
  if (!accessToken) {
    return null;
  }

  const parts = accessToken.split(".");
  if (parts.length < 2) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = atob(padded);
    const payload = JSON.parse(json) as { user_id?: number | string; sub?: string };
    const raw = payload.user_id ?? payload.sub;
    if (typeof raw === "number" && Number.isFinite(raw)) {
      return raw;
    }
    if (typeof raw === "string" && /^\d+$/.test(raw)) {
      return Number(raw);
    }
    return null;
  } catch {
    return null;
  }
}
